import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  IconButton,
  Typography,
  Avatar,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import EmailIcon from "@mui/icons-material/Email";

const CategoryTableDialog = ({
  open,
  onClose,
  selectedCategory,
  categoryPeople,
  chartTab,
  gradeStats,
  levelStats,
  onPersonClick,
}) => {
  const getCategoryColor = () => {
    if (chartTab === 2) {
      // Grade tab
      if (selectedCategory && selectedCategory !== "Unassigned") {
        return gradeStats.getGradeColor(selectedCategory);
      } else if (selectedCategory === "Unassigned") {
        return "#777";
      }
      return "#2185d0";
    } else {
      // Level tab
      return levelStats.getLevelColor(selectedCategory);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle
        sx={{
          backgroundColor: getCategoryColor(),
          color: "#fff",
          padding: "12px 16px",
        }}
      >
        <Grid container alignItems="center" justifyContent="space-between">
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            {chartTab === 2
              ? selectedCategory === "Unassigned"
                ? selectedCategory
                : `Grade ${selectedCategory}`
              : "Level: " + selectedCategory}
            ({categoryPeople.length} Staff)
          </Typography>
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              color: "#fff",
              backgroundColor: "rgba(255,255,255,0.1)",
              "&:hover": {
                backgroundColor: "rgba(255,255,255,0.2)",
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </Grid>
      </DialogTitle>
      <DialogContent dividers sx={{ padding: "16px" }}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                <TableCell sx={{ fontWeight: "bold" }}>Name</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Staff ID</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Role</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Department</TableCell>
                {chartTab === 2 ? (
                  <TableCell sx={{ fontWeight: "bold" }}>Level</TableCell>
                ) : (
                  <TableCell sx={{ fontWeight: "bold" }}>Grade</TableCell>
                )}
                <TableCell sx={{ fontWeight: "bold" }}>Country</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Contact</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {categoryPeople.map((person) => (
                <TableRow
                  key={person.id}
                  onClick={() => onPersonClick(person)}
                  sx={{
                    cursor: "pointer",
                    "&:hover": {
                      backgroundColor:
                        chartTab === 2
                          ? "rgba(54, 162, 235, 0.05)"
                          : "rgba(153, 102, 255, 0.05)",
                    },
                  }}
                >
                  <TableCell>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Avatar
                        src={person.profile_image}
                        alt={person.name}
                        sx={{ width: 32, height: 32, mr: 1 }}
                      >
                        {person.name ? person.name.charAt(0).toUpperCase() : "?"}
                      </Avatar>
                      {person.name}
                    </Box>
                  </TableCell>
                  <TableCell>{person.staff_id}</TableCell>
                  <TableCell>{person.role_name}</TableCell>
                  <TableCell>{person.dep_name || "Not assigned"}</TableCell>
                  {chartTab === 2 ? (
                    <TableCell>{person.level}</TableCell>
                  ) : (
                    <TableCell>
                      {person.grade_id
                        ? `Grade ${person.grade_id}`
                        : "Unassigned"}
                    </TableCell>
                  )}
                  <TableCell>{person.res_country}</TableCell>
                  <TableCell>
                    <a
                      href={`mailto:${person.per_email || person.login_id}`}
                      onClick={(e) => e.stopPropagation()}
                      style={{
                        color: chartTab === 2 ? "#2185d0" : "#9c27b0",
                        textDecoration: "none",
                      }}
                    >
                      <EmailIcon fontSize="small" />
                    </a>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        {categoryPeople.length === 0 && (
          <Typography
            sx={{ textAlign: "center", p: 3, color: "text.secondary" }}
          >
            No staff found in this {chartTab === 2 ? "grade" : "level"}
          </Typography>
        )}
      </DialogContent>
      <DialogActions sx={{ padding: "16px" }}>
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{
            color: getCategoryColor(),
            borderColor: getCategoryColor(),
            "&:hover": {
              borderColor:
                chartTab === 2
                  ? selectedCategory && selectedCategory !== "Unassigned"
                    ? gradeStats.getGradeColor(selectedCategory)
                    : selectedCategory === "Unassigned"
                    ? "#555"
                    : "#1976d2"
                  : levelStats.getLevelColor(selectedCategory).replace("1", "0.8"),
              backgroundColor: `${getCategoryColor()}15`,
            },
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CategoryTableDialog;
